






















import { Vue, Component } from "vue-property-decorator";
import { BButton } from "bootstrap-vue";

@Component({
    components: { BButton },
})
export default class Landing extends Vue {
    public get title(): string {
        return this.$alt.config.about.title;
    }
}
